import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import { AppInterceptor } from './core/interceptors/http.interceptor';
import { GlobalErrorHandler } from './core/error-handlers/global-error-handler';
import { provideTranslateService } from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';

export const appConfig: ApplicationConfig = {
providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
      { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
      { provide: ErrorHandler, useClass: GlobalErrorHandler},
    provideTranslateService({
      loader: provideTranslateHttpLoader({prefix:"./i18n/", suffix:".json"}),
    })
 
    ]
  };
